export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/login/:segmento',
    name: 'loginWithSegment',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/error/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  // {
  //     path: '/pages/authentication/forgot-password-v2',
  //     name: 'auth-forgot-password-v2',
  //     component: () => import('@/views/pages/authentication/ForgotPassword-v2.vue'),
  //     meta: {
  //         layout: 'full',
  //         resource: 'Auth',
  //     },
  // },
  {
    path: '/pages/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/reset-password-v2/:token/:id',
    name: 'auth-reset-password-v2',
    component: () => import('@/views/pages/authentication/ResetPassword-v2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
];
